const accountsdata = [
    {
        "_id": "65c8f8f60c83d10491afb1fd",
        "name": "Imperial College",
        "country": "United Kingdom",
        "city": "London",
        "address": "Imperial College London,Exhibition Road, London SW7 2AZ",
        "Qsranking": 6,
        "Guardianranking": 1,
        "website": "https://www.imperial.ac.uk/",
        "coursesOffered": [],
        "__v": 0
    },
    {
        "_id": "65c8f8690c83d10491afb1fb",
        "name": "London School of Economics",
        "country": "United Kingdom",
        "city": "London",
        "address": "Houghton St, London WC2A 2AE, United Kingdom",
        "Qsranking": 45,
        "Guardianranking": 2,
        "website": "https://www.lse.ac.uk/",
        "coursesOffered": [],
        "__v": 0
    },
    {
        "_id": "65c8f7920c83d10491afb1f7",
        "name": "Oxford",
        "country": "United Kingdom",
        "city": "England",
        "address": "Wellington Square, Oxford OX1 2JD, United Kingdom",
        "Qsranking": 3,
        "Guardianranking": 3,
        "website": "https://www.ox.ac.uk/",
        "coursesOffered": [],
        "__v": 0
    },
    {
        "_id": "65c8f7f10c83d10491afb1f9",
        "name": "Cambridge",
        "country": "United Kingdom",
        "city": "England",
        "address": "The Old Schools, Trinity Ln, Cambridge CB2 1TN, United Kingdom",
        "Qsranking": 2,
        "Guardianranking": 4,
        "website": "https://www.cam.ac.uk/",
        "coursesOffered": [],
        "__v": 0
    },
    {
        "_id": "65c8f9760c83d10491afb1ff",
        "name": "Durham University",
        "country": "United Kingdom",
        "city": "England",
        "address": "The Palatine Centre, University, Stockton Rd, Durham DH1 3LE, UK",
        "Qsranking": 78,
        "Guardianranking": 5,
        "website": "https://www.durham.ac.uk/",
        "coursesOffered": [],
        "__v": 0
    },
    {
        "_id": "65c8fa0e0c83d10491afb201",
        "name": "University of Bath",
        "country": "United Kingdom",
        "city": "England",
        "address": "Claverton Down, Bath BA2 7AY, United Kingdom",
        "Qsranking": 78,
        "Guardianranking": 6,
        "website": "https://www.bath.ac.uk/",
        "coursesOffered": [],
        "__v": 0
    },
    {
        "_id": "65c8fa7e0c83d10491afb203",
        "name": "University of Warwick",
        "country": "United Kingdom",
        "city": "England",
        "address": "University of Warwick, Coventry CV4 7AL, UK",
        "Qsranking": 67,
        "Guardianranking": 7,
        "website": "https://warwick.ac.uk/",
        "coursesOffered": [],
        "__v": 0
    },
    {
        "_id": "65c8fada0c83d10491afb205",
        "name": "UCL",
        "country": "United Kingdom",
        "city": "England",
        "address": "Gower St, London WC1E 6BT, United Kingdom",
        "Qsranking": 9,
        "Guardianranking": 8,
        "website": "https://www.ucl.ac.uk/",
        "coursesOffered": [],
        "__v": 0
    },
    {
        "_id": "65c8fb440c83d10491afb207",
        "name": "Loughborough University",
        "country": "United Kingdom",
        "city": "England",
        "address": "Epinal Way, Loughborough LE11 3TU, United Kingdom",
        "Qsranking": 212,
        "Guardianranking": 9,
        "website": "https://www.lboro.ac.uk/",
        "coursesOffered": [],
        "__v": 0
    }
] 

export default accountsdata;